// mixins/device.js
export default {
    data() {
      return {
        isMobile: false,
        isAppleApp: false,
      };
    },
    methods: {
      checkDevice() {
        this.isMobile = window.innerWidth <= 991;
        this.isAppleApp = window.webkit && window.webkit.messageHandlers;
      },
    },
    mounted() {
      this.checkDevice();
      window.addEventListener('resize', this.checkDevice);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkDevice);
    },
  };


// WEBPACK FOOTER //
// ./src/mixins/device.js